/* eslint-disable jsx-a11y/anchor-is-valid */
export const mockList = [
  'Part 121, Part 125, Part 135 Certifi...',
  'Part 91 LOAs',
  'RNP Authorization',
  'EASA TCO Authorizations',
  'RVSM Manuals',
  'General Maintenance Manual',
  'General Operations Manual',
  'Minimum Equipment List',
  'AMU OpSpecs B040',
  'Polar Operations OpSpecs B055',
  'Oceanic & PBN procedures.',
  'Continually Evolving SMS'
]

export const mockIndustry = [
  {
    title: 'Polar Operations OpSpecs B055 to Part 135 Operators',
    content: 'With ultra-long-range aircraft with greater range such as the G650 and Global G6000 the need for polar routes needed to be available for 135 operators. OpSpecs B055 was not even available before we coordinated with FAA offices (Washington DC and the Van Nuys FSDO). We were the first to gain the authorization for 135 operators and paved the way for the industry.',
    link: <p style={{ display: 'flex', alignItems: 'center' }}><a href='/contact-us' className='industry__a'>Contact a Team Member</a> to learn more about this service.</p>
  },
  {
    title: 'CAT II/CAT IIIb Authorization Part 125',
    content: 'When one of Boeing 767 part 125 operators needed lower authorization. We were able to work with the Houston FSDO to receive the first CAT IIIb for a part 125 aircraft. No other aircraft outside of 121 had this lower authorization before we were able to obtain the OpSpecs C060.',
    link: <p style={{ display: 'flex', alignItems: 'center' }}><a href='/contact-us' className='industry__a'>Contact a Team Member</a> to learn more about this service.</p>
  },
  {
    title: 'SMS Manual and Data Collection System LevelFlight',
    content: 'Since 2002 Fly Compliant, LLC has been developing SMS processes and procedures. What we added was the ability to collect the data with proprietary software LevelFlight.com. We created a software platform and manual system to reduce risks. LevelFlight continues to innovate and evolve as a pioneer platform in SMS.',
    link: <p style={{ display: 'flex', alignItems: 'center' }}><a href='/contact-us' className='industry__a'>Contact a Team Member</a> to learn more about this service.</p>
  },
  {
    title: 'Electronic Records OpSpecs A025 for Part 135 at many FSDOs',
    content: 'Working together with LAX FSDO in 1995 we started building the platform that would become LevelFlight.com, offering OpSpecs A025. The guidance initially did not even afford 135 operators the ability to be issued OpSpecs A025 for electronic recordkeeping.',
    link: <p style={{ display: 'flex', alignItems: 'center' }}><a href='/contact-us' className='industry__a'>Contact a Team Member</a> to learn more about this service.</p>
  },
  {
    title: 'CASS Using SMS',
    content: 'Fly Compliant, LLC was the first to adapt a Safety Management System for managing a Continuous Airworthiness Surveillance System (CASS). We have successfully incorporated CASS into our LevelFlight SMS. CASS and SMS follow the same processes and LevelFlight tracks and manages maintenance events. By following FAA guidance we were able to provide a process to manage maintenance risk. The result FAA acceptance of our General Maintenance Manual CASS policies and procedures.',
    link: <p style={{ display: 'flex', alignItems: 'center' }}><a href='/contact-us' className='industry__a'>Contact a Team Member</a> to learn more about this service.</p>
  },
  {
    title: 'Automated Risk Assessment (ARA)',
    content: 'As part of our continually evolving SMS we have developed and added to our flight release an objective Automated Risk Assessment (ARA). The ARA reviews all the associated data related to a flight release to include, aircraft status, airport factors (runway length and evaluation), pilots currency and rest along with weather. The ARA provides the company and pilots with an objective risk score at the time of departure. The benefits of the report is an easily understood risk assessment with an associated audit detailing the factors for deriving the score. Another benefit is a comprehensive threat briefing detailing the known risks for pilots, further enhancing safety.',
    link: <p style={{ display: 'flex', alignItems: 'center' }}><a href='/contact-us' className='industry__a'>Contact a Team Member</a> to learn more about ARA.</p>
  }
]

export const mockComplianceServices = [
  {
    id: '1',
    title: 'About Fly Compliant',
    content: 'Solving operational compliance through advanced digital solutions.'
  },
  {
    id: '2',
    title: 'Compliance Management',
    content: 'Compliance Assistance Program providing assistance in all areas of operations.'
  }, {
    id: '3',
    title: 'Certification Services',
    content: 'Part 91. Part 121. Part 125. Part 135.'
  },
  {
    id: '4',
    title: 'Digital Solutions',
    content: 'A properly designed and clearly documented manual system.'
  },
  {
    id: '5',
    title: 'SMS',
    content: 'A Collective Approach to SMS. A systemic approach to managing risk.'
  }
]

export const mockSearchData = [
  {
    id: '1',
    title: 'Article Title',
    content: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus a dolor vitae quam elementum hendrerit. Vestibulum ligula lorem, condimentum nec ultricies ut, convallis sit amet quam. Donec tempor, dui ultricies vehicula efficitur, sapien ante dictum lectus, quis tempor dui justo et lacus. ',
  },
  {
    id: '2',
    title: 'Article Title',
    content: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus a dolor vitae quam elementum hendrerit. Vestibulum ligula lorem, condimentum nec ultricies ut, convallis sit amet quam. Donec tempor, dui ultricies vehicula efficitur, sapien ante dictum lectus, quis tempor dui justo et lacus. ',
  },
  {
    id: '3',
    title: 'Article Title',
    content: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus a dolor vitae quam elementum hendrerit. Vestibulum ligula lorem, condimentum nec ultricies ut, convallis sit amet quam. Donec tempor, dui ultricies vehicula efficitur, sapien ante dictum lectus, quis tempor dui justo et lacus. ',
  },
  {
    id: '4',
    title: 'Article Title',
    content: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus a dolor vitae quam elementum hendrerit. Vestibulum ligula lorem, condimentum nec ultricies ut, convallis sit amet quam. Donec tempor, dui ultricies vehicula efficitur, sapien ante dictum lectus, quis tempor dui justo et lacus. ',
  }
]

export const mockProductsData = [
  {
    id: '1',
    title: 'FAA Compliance Systems',
    content: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus a dolor vitae quam elementum hendrerit. ',
    link: <a className='products__link' href="#">Learn More</a>
  },
  {
    id: '2',
    title: 'Operations Management',
    content: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus a dolor vitae quam elementum hendrerit. ',
    link: <a className='products__link' href="https://www.levelflight.com" target="_blank" rel="noreferrer">Explore LevelFlight</a>
  },
  {
    id: '3',
    title: 'FAA & EASA Compliance',
    content: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus a dolor vitae quam elementum hendrerit. ',
    link: <a className='products__link' href="#">Learn More</a>
  },
  {
    id: '4',
    title: 'Certification Services',
    content: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus a dolor vitae quam elementum hendrerit. ',
    link: <a className='products__link' href="#">Learn More</a>
  },
  {
    id: '5',
    title: 'Safety Management Services',
    content: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus a dolor vitae quam elementum hendrerit. ',
    link: <a className='products__link' href="#">Learn More</a>
  },
  {
    id: '6',
    title: 'Latest news',
    content: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus a dolor vitae quam elementum hendrerit. ',
    link: ''
  },
]

export const mockIntroData = [
  {
    title: 'Quoting',
    content: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus a dolor vitae quam elementum hendrerit. ',
  },
  {
    title: 'Scheduling & Dispatching',
    content: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus a dolor vitae quam elementum hendrerit. ',
  },
  {
    title: 'Pilot Records',
    content: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus a dolor vitae quam elementum hendrerit. ',
  },
  {
    title: 'Manual Development & Distribution',
    content: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus a dolor vitae quam elementum hendrerit. ',
  },
  {
    title: 'Safety Management System (SMS)',
    content: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus a dolor vitae quam elementum hendrerit. ',
  },
  {
    title: 'Expenses',
    content: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus a dolor vitae quam elementum hendrerit. ',
  },
  {
    title: 'CASS Management',
    content: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus a dolor vitae quam elementum hendrerit. ',
  },
]

export const mockBookData = [
  {
    title: 'Running a Paperless Operation',
    content: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus a dolor vitae quam elementum hendrerit. ',
  },
  {
    title: 'Keeping a 135 Compliant Operation',
    content: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus a dolor vitae quam elementum hendrerit. ',
  },
  {
    title: 'Evolving Schedule of Events',
    content: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus a dolor vitae quam elementum hendrerit. ',
  }
]

export const mockIndustryProblem = [
  'Antiquated Standards',
  'Complexity',
  'Compression of Time',
  'Fatigue',
  'Loss of Experience',
  'Unintentional Non-Compliance',
  'Reduce Captain’s Authority',
  'Reducing Ground Occurrences',
  'Risk > 1',
  'Ruling by Guidances',
  'Too Many Changes to Operations',
  'Training Gap & Reliance on Distance Learning'
]

export const mockSolveProblems = [
  'Create manuals and get certified by the FAA.',
  'Train your people.',
  'Use LevelFlight software to manage your operation and stay compliant.'
]